// Mock data pour Nina Care Institut

export const services = [
  {
    id: 1,
    category: "SOINS DU VISAGE",
    title: "Soin énergie vitale + VAPEUR",
    description: "Soin purifiant avec vapeur pour une peau éclatante et revitalisée",
    duration: "1h 5min",
    price: 65,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
  },
  {
    id: 2,
    category: "SOINS DU VISAGE",
    title: "Soin Hydratant",
    description: "Soin hydratant profond pour peaux déshydratées",
    duration: "50min",
    price: 55,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
  },
  {
    id: 3,
    category: "SOINS DU VISAGE",
    title: "Soin instant précieux",
    description: "Soin anti-âge pour une peau visiblement rajeunie",
    duration: "1h 5min",
    price: 70,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
  },
  {
    id: 4,
    category: "SOINS DU VISAGE",
    title: "Mini soin éclat",
    description: "Soin express pour retrouver instantanément l'éclat",
    duration: "35min",
    price: 40,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
  },
  {
    id: 5,
    category: "SOINS DU CORPS",
    title: "Modelage anti-stress",
    description: "Massage relaxant complet pour éliminer les tensions",
    duration: "1h 5min",
    price: 70,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/kfq989rf_D5E57FC3-27D4-4BB5-B51A-B5BBD659A26B.png"
  },
  {
    id: 6,
    category: "SOINS DU CORPS",
    title: "Gommage corps",
    description: "Exfoliation douce pour une peau soyeuse",
    duration: "30min",
    price: 40,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/kfq989rf_D5E57FC3-27D4-4BB5-B51A-B5BBD659A26B.png"
  },
  {
    id: 7,
    category: "SOINS DU CORPS",
    title: "Massage à la bougie",
    description: "Modelage relaxant aux huiles parfumées",
    duration: "45min",
    price: 55,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/kfq989rf_D5E57FC3-27D4-4BB5-B51A-B5BBD659A26B.png"
  },
  {
    id: 8,
    category: "SOINS DU CORPS",
    title: "Massage Corps Duo",
    description: "Une parenthèse de bien-être à deux",
    duration: "60min",
    price: 95,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/v9rwxora_2F095139-8230-4A05-8649-666522B1FACE.png"
  },
  {
    id: 9,
    category: "BEAUTÉ DES MAINS",
    title: "Manucure + Semi-permanent",
    description: "La manucure signature Institut: une tenu sublime et lumineuse qui dure impeccablement",
    duration: "50min",
    price: 47,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/mrslefe8_B040167A-2881-419B-ABCA-43049B42C5CA.png"
  },
  {
    id: 10,
    category: "BEAUTÉ DES MAINS",
    title: "French semi-permanent",
    description: "French manucure élégante avec vernis longue durée",
    duration: "50min",
    price: 50,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/mrslefe8_B040167A-2881-419B-ABCA-43049B42C5CA.png"
  },
  {
    id: 11,
    category: "ÉPILATIONS FEMME",
    title: "Création des sourcils",
    description: "Design et mise en forme des sourcils",
    duration: "15min",
    price: 18,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/krqqvob3_5969536F-C7A5-4C33-BAE4-9BC307660C97.png"
  },
  {
    id: 12,
    category: "ÉPILATIONS FEMME",
    title: "Demi-jambes",
    description: "Nos gestes maîtrisés et nos cires ultra-douces garantissent une précision parfaite et un confort absolu",
    duration: "20min",
    price: 21,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/krqqvob3_5969536F-C7A5-4C33-BAE4-9BC307660C97.png"
  },
  {
    id: 13,
    category: "SUN COSMETICS",
    title: "Sun Visage + Corps",
    description: "Bronzage sans UV pour un teint hâlé naturel avec Sun Cosmétique France",
    duration: "15min",
    price: 70,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/m9m1mvno_IMG_8486.png"
  },
  {
    id: 14,
    category: "BEAUTÉ DU REGARD",
    title: "Réhaussement de cils",
    description: "Rehaussement et courbure naturelle des cils",
    duration: "50min",
    price: 57,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
  },
  {
    id: 15,
    category: "BEAUTÉ DU REGARD",
    title: "Teinture Cils + Sourcils",
    description: "Teinture pour un regard intensifié",
    duration: "30min",
    price: 35,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4u4ioul_9DDC9875-A45A-4210-BB79-003216C6BDDB.png"
  }
];

export const forfaits = [
  {
    id: 1,
    title: "Forfait Épilation Complète",
    description: "Demi-jambes + aisselles + maillot intégral",
    duration: "50min",
    price: 56,
    services: ["Demi-jambes", "Aisselles", "Maillot intégral"]
  },
  {
    id: 2,
    title: "Forfait Beauté Complète",
    description: "Manucure + pédicure avec semi-permanent",
    duration: "2h",
    price: 95,
    services: ["Manucure", "Pédicure", "Semi-permanent"]
  }
];

export const gallery = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d4uibxiz_F381479D-3538-467C-960B-DECA3DE28447.png",
    title: "Devanture Nina Care Institut",
    category: "Institut"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/optc0m5i_F68296A5-8BB0-4D19-BEAA-179761012DAA.png",
    title: "Accueil & Réception",
    category: "Institut"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/qjygyalw_80EF3F51-01F3-4A72-8EC7-2A176E34D23D.png",
    title: "Salle d'attente rose",
    category: "Institut"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/qtw2pu27_475FC69A-0104-4BEB-9488-7EA4B2AD6A7C.png",
    title: "Espace Manucure",
    category: "Institut"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/0x4hkfvr_958ABF30-E990-48BE-BCBC-B8AF2381BA25.png",
    title: "Salle d'épilation",
    category: "Institut"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/ul01pi4f_E878FE7C-EEBB-483E-8F06-93E4FEBAEE7D.png",
    title: "Salle d'attente zen",
    category: "Institut"
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/26tdnb7p_IMG_8214.png",
    title: "Salle de massage anti-stress",
    category: "Institut"
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/1m2viwni_4E30A997-0135-424D-9FD1-D52D5D826062.png",
    title: "Salle de soins professionnelle",
    category: "Institut"
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/u2wa494q_5C4B2D8C-068D-49D7-B25A-F914528B185B.png",
    title: "Espace massage détente",
    category: "Institut"
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/wxl3lr8t_7F8DC210-21DD-49B5-863F-A33726182FF0.png",
    title: "Salle de massage zen",
    category: "Institut"
  },
  {
    id: 11,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/c2bhqbho_EE060487-F339-4D63-B4B5-2697144AE94C.png",
    title: "Ambiance chromothérapie",
    category: "Institut"
  },
  {
    id: 12,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/ev7zob41_7CE099A9-5D08-42B0-A23C-303CEDD77965.png",
    title: "Cabine de soin vapeur",
    category: "Institut"
  },
  {
    id: 13,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/9dw68s54_338BBDA6-EC3C-472B-B2F2-42B5CCE0C645.png",
    title: "Escalier vers l'étage bien-être",
    category: "Institut"
  },
  {
    id: 14,
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/cptwenav_EA3E9974-674C-4523-8BC2-0AE41536D26E.png",
    title: "Espace détente bambou",
    category: "Institut"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    rating: 5,
    comment: "Institut magnifique avec des prestations de qualité. Ludivine est très professionnelle et à l'écoute.",
    date: "Janvier 2026"
  },
  {
    id: 2,
    name: "Marie L.",
    rating: 5,
    comment: "Accueil chaleureux et soins exceptionnels. Je recommande vivement !",
    date: "Décembre 2025"
  },
  {
    id: 3,
    name: "Claire D.",
    rating: 5,
    comment: "Un vrai moment de détente. Le modelage anti-stress est incroyable !",
    date: "Janvier 2026"
  }
];

export const team = [
  {
    id: 1,
    name: "Ludivine",
    role: "Fondatrice & Esthéticienne",
    description: "Passionnée par les soins esthétiques, Ludivine met son expertise au service de votre beauté.",
    specialties: ["Soins du visage", "Épilations", "Modelages"]
  },
  {
    id: 2,
    name: "Mélissa",
    role: "Esthéticienne",
    description: "Spécialiste en manucure et beauté du regard, Mélissa sublime votre beauté avec précision.",
    specialties: ["Manucure", "Pédicure", "Réhaussement de cils"]
  }
];

export const contact = {
  phone: "09 84 63 03 27",
  email: "nc.institut91@gmail.com",
  address: "130 Route de Corbeil",
  city: "91360 Villemoisson-sur-Orge",
  hours: {
    lundi: "Fermé",
    mardi: "10h - 19h",
    mercredi: "10h - 19h",
    jeudi: "10h - 19h",
    vendredi: "10h - 19h",
    samedi: "9h - 18h",
    dimanche: "Fermé"
  },
  social: {
    facebook: "https://www.facebook.com/ninacareinstitut",
    instagram: "https://www.instagram.com/ninacareinstitut",
    planity: "https://www.planity.com/nina-care-institut-91360-villemoisson-sur-orge",
    treatwell: "https://www.treatwell.fr/salon/nina-care-institut-1/"
  }
};

export const specialOffers = [
  {
    id: 1,
    title: "Offre Saint-Valentin",
    subtitle: "Duo romantique",
    description: "Massage Duo 60min pour partager un moment de détente à deux",
    originalPrice: 140,
    specialPrice: 95,
    discount: "-32%",
    validUntil: "21 février 2026",
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/cptwenav_EA3E9974-674C-4523-8BC2-0AE41536D26E.png",
    badge: "Offre limitée",
    isHighlight: true
  },
  {
    id: 2,
    title: "Forfait Beauté Complète",
    subtitle: "Mains parfaites",
    description: "Manucure + Semi-permanent pour des mains impeccables",
    originalPrice: 47,
    specialPrice: 37,
    discount: "-21%",
    validUntil: "29 février 2026",
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/qtw2pu27_475FC69A-0104-4BEB-9488-7EA4B2AD6A7C.png",
    badge: "Nouveauté",
    isHighlight: false
  },
  {
    id: 3,
    title: "Découverte Bronzage",
    subtitle: "Teint hâlé naturel",
    description: "Sun Visage + Cou pour un éclat doré instantané",
    originalPrice: 25,
    specialPrice: 20,
    discount: "-20%",
    validUntil: "15 mars 2026",
    image: "https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/qjygyalw_80EF3F51-01F3-4A72-8EC7-2A176E34D23D.png",
    badge: "Populaire",
    isHighlight: false
  }
];

export const aboutContent = {
  title: "À Propos de Nina Care Institut",
  description: "Ouvert fin 2025, Nina Care Institut est un institut de beauté dédié au bien-être et à la mise en valeur naturelle de chaque client(e).",
  mission: "Tenu par Ludivine, professionnelle passionnée et rigoureuse, l'institut vous accueille avec Mélissa dans un cadre apaisant à Villemoisson-sur-Orge, où chaque prestation est réalisée avec précision et exigence de qualité.",
  naturalProducts: {
    title: "Excellence Naturelle",
    description: "Chez Nina Care Institut, nous avons fait le choix de l'excellence naturelle. Chaque soin du visage est réalisé avec une sélection rigoureuse de produits d'exception, composés à 99% d'ingrédients d'origine naturelle.",
    facialCare: "Acide hyaluronique, Aloe Vera, extraits de blé et de betterave : notre signature réside dans cette alliance parfaite entre efficacité scientifique et pureté botanique, pour révéler l'éclat naturel de votre peau.",
    tanning: "Votre teint hâlé sublimé par Bronzag'Expert 4ème génération. Notre bronzage par pulvérisation utilise exclusivement des formules 100% naturelles, fabriquées en France avec un activateur de mélanine et un agent bronzant d'origine végétale."
  },
  values: [
    {
      title: "Expertise",
      description: "Des professionnelles formées aux dernières techniques"
    },
    {
      title: "Qualité",
      description: "99% d'ingrédients naturels, sans silicone, sans parabène"
    },
    {
      title: "Hygiène",
      description: "Protocoles stricts pour votre sécurité et votre confort"
    },
    {
      title: "Éthique",
      description: "Produits non testés sur les animaux, sans OGM, fabriqués en France"
    }
  ],
  commitments: [
    {
      icon: "✨",
      title: "99% d'ingrédients naturels",
      description: "Acide hyaluronique, Aloe Vera, extraits végétaux"
    },
    {
      icon: "🇫🇷",
      title: "Fabriqué en France",
      description: "Qualité et traçabilité garanties"
    },
    {
      icon: "🐰",
      title: "Non testé sur les animaux",
      description: "Éthique et respect du vivant"
    },
    {
      icon: "🌱",
      title: "Sans OGM, sans nanoparticules",
      description: "Formules saines pour votre peau"
    },
    {
      icon: "💎",
      title: "Technologie Bronzag'Expert",
      description: "Équipement professionnel 4ème génération"
    }
  ]
};

// Tarifs groupés par catégorie
export const pricingCategories = [
  {
    category: "SOINS DU VISAGE",
    services: [
      { name: "Mini soin éclat", duration: "35min", price: 40 },
      { name: "Soin Hydratant (peau déshydratée)", duration: "50min", price: 55 },
      { name: "Soin énergie vitale + VAPEUR", duration: "1h05", price: 65 },
      { name: "Soin apaisant", duration: "50min", price: 67 },
      { name: "Soin instant précieux (anti-âge)", duration: "1h05", price: 70 }
    ]
  },
  {
    category: "SOINS DU CORPS",
    services: [
      { name: "Modelage relax", duration: "15min", price: 25 },
      { name: "Gommage corps", duration: "30min", price: 40 },
      { name: "Modelage détente", duration: "35min", price: 40 },
      { name: "Massage à la bougie", duration: "45min", price: 55 },
      { name: "Modelage anti-stress", duration: "1h05", price: 70 }
    ]
  },
  {
    category: "ÉPILATIONS FEMME",
    services: [
      { name: "Sourcils entretien", duration: "15min", price: 14 },
      { name: "Lèvres", duration: "10min", price: 11 },
      { name: "Sourcils + lèvres", duration: "15min", price: 20 },
      { name: "Création des sourcils", duration: "15min", price: 18 },
      { name: "Demi-jambes", duration: "20min", price: 21 },
      { name: "Jambes complètes", duration: "35min", price: 29 },
      { name: "Aisselles", duration: "10min", price: 12 },
      { name: "Maillot classique", duration: "15min", price: 16 },
      { name: "Maillot intégral", duration: "25min", price: 30 }
    ]
  },
  {
    category: "BEAUTÉ DES MAINS",
    services: [
      { name: "Manucure + Base", duration: "30min", price: 25 },
      { name: "Pose vernis semi-permanent", duration: "40min", price: 32 },
      { name: "French semi-permanent", duration: "45min", price: 35 },
      { name: "Manucure + semi-permanent", duration: "50min", price: 47 },
      { name: "Manucure + french semi", duration: "50min", price: 50 }
    ]
  },
  {
    category: "BEAUTÉ DES PIEDS",
    services: [
      { name: "Beauté des pieds + Base", duration: "30min", price: 38 },
      { name: "Pose vernis semi-permanent pieds", duration: "40min", price: 35 },
      { name: "French semi-permanent", duration: "40min", price: 39 },
      { name: "Beauté des pieds + semi-permanent", duration: "1h10", price: 58 }
    ]
  },
  {
    category: "BEAUTÉ DU REGARD",
    services: [
      { name: "Teinture sourcils", duration: "20min", price: 20 },
      { name: "Teinture cils", duration: "20min", price: 25 },
      { name: "Teinture cils + sourcils", duration: "30min", price: 35 },
      { name: "Réhaussement de cils", duration: "50min", price: 57 },
      { name: "Rehaussement + teinture cils", duration: "1h", price: 67 }
    ]
  },
  {
    category: "SUN COSMETICS",
    services: [
      { name: "Sun Visage + Cou", duration: "10min", price: 20 },
      { name: "Sun Visage + Cou + Décolleté", duration: "10min", price: 25 },
      { name: "Sun Corps", duration: "15min", price: 60 },
      { name: "Sun Visage + Corps", duration: "15min", price: 70 }
    ]
  }
];
